'use strict';

import React from 'react';

import InitialsIcon from '../../InitialsIcon/InitialsIcon'
import ListItemDetail from './ListItemDetail/ListItemDetail';
import { OnSchedUtils } from '../../../utils';


const ListItem = ({ item, properties, image, element, event }) => {
  // Use array of properties to create the value in each column of the table
  // Find and replace all values in curly braces with the values from the item
  let itemDetails = properties.map((prop, idx) => {
    let newReplacedProperty = {};
    var replacedProperty; 
    
    if (typeof prop === 'string') {
      replacedProperty = prop;
      newReplacedProperty.text = prop;
      
      prop.match(/[^{\}]+(?=})/g).forEach(p => {
        if (!p.includes('.')) {
          replacedProperty = replacedProperty.replace(`{${p}}`, item[p]);
          newReplacedProperty.text = newReplacedProperty.text.replace(`{${p}}`, item[p]);
        }
        else {
          let basePath = item[p.split('.')[0]];
          
          for (var i = 1;i < p.split('.').length;i++) {
            basePath = basePath[p.split('.')[i]];
          }
          
          replacedProperty = replacedProperty.replace(`{${p}}`, basePath);
          newReplacedProperty.text = newReplacedProperty.text.replace(`{${p}}`, basePath);
        }
      })
    }
    else if (typeof prop === 'object') {
      if (item[prop.dynamicTrigger]) {
        // Need dropdown
        newReplacedProperty.dropdown = {
          type: item.object,
          options: []
        };
        
        const dropdownElement = document.createElement('SELECT');
        dropdownElement.className = 'ListItemDropdown';

        for (var i = item[prop.min]; i <= item[prop.max]; i += item[prop.interval]) {
          const option = document.createElement('OPTION');
          option.value = i;
          option.text = prop.value.replace(`{${prop.propertyName}}`, i);
          
          dropdownElement.add(option);

          newReplacedProperty.dropdown.options.push({ text: prop.value.replace(`{${prop.propertyName}}`, i), value: i })
        }

        replacedProperty = dropdownElement.outerHTML;
      }
      else {
        // No dropdown
        replacedProperty = prop.value;
        newReplacedProperty.text = prop.value;
      
        prop.value.match(/[^{\}]+(?=})/g).forEach(p => {
          if (!p.includes('.')) {
            replacedProperty = replacedProperty.replace(`{${p}}`, item[p]);
            newReplacedProperty.text = newReplacedProperty.text.replace(`{${p}}`, item[p]);
          }
          else {
            let basePath = item[p.split('.')[0]];
            
            for (var i = 1;i < p.split('.').length;i++) {
              basePath = basePath[p.split('.')[i]];
            }
            
            replacedProperty = replacedProperty.replace(`{${p}}`, basePath);
            newReplacedProperty.text = newReplacedProperty.text.replace(`{${p}}`, basePath);
          }
        })
      }
    }

    return newReplacedProperty;
    // return <td key={idx} dangerouslySetInnerHTML={{__html: replacedProperty}}></td>;
  })

  return (
    <tr 
      className='ListItem onsched-shadow-background-color onsched-secondary-background-color-hover noselect' 
    >
      <td><InitialsIcon name={item.name} imgUrl={item[image]} /></td>
      <td><ListItemDetail element={element} event={event} item={item} detail={itemDetails} /></td>
      {/* {itemDetails} */}
    </tr>
  );
}

export default ListItem
